import { useEffect, useRef } from "react";
import { AccountProfileActionResponse } from "~/entities/actions/types";
import useCreateAccountWizard from "~/hooks/useCreateAccountWizard";
import ErrorMessage from "./ErrorMessage";
import Field from "./Field";
import SubmitButton from "./SubmitButton";

type Props = {
  onSuccess: () => void;
  isActive: boolean;
};

const CompleteProfile: React.FC<Props> = ({ onSuccess, isActive }) => {
  const { errors, fetcher } =
    useCreateAccountWizard<AccountProfileActionResponse>(onSuccess);

  const nameRef = useRef<HTMLInputElement>(null);
  const phoneRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (errors["name"] && nameRef.current) {
      nameRef.current.focus();
    } else if (errors["phone"] && phoneRef.current) {
      phoneRef.current.focus();
    } else if (isActive && nameRef.current) {
      nameRef.current.focus();
    }
  }, [isActive, errors]);

  if (!isActive) return null;

  return (
    <fetcher.Form
      method="post"
      action="/resources/create-account-wizard"
      className="flex flex-col gap-7 xsm:gap-4 md:gap-3.5 px-5"
      data-testid="complete-profile-form"
    >
      <input
        type="hidden"
        name="intent"
        value="complete_profile"
      />
      <h2 className="text-[20px] text-blue900 font-sans mt-0 uppercase font-bold">
        Complete your profile.
      </h2>

      <ErrorMessage error={errors["form"]} />

      <Field
        label="Name"
        name="name"
        ariaLabel="Enter your first and last name"
        placeholder="John Smith"
        error={errors["name"]}
        ref={nameRef}
      />

      <Field
        label="Phone Number"
        name="phone"
        ariaLabel="Enter your 10-digit phone number"
        placeholder="(555) 555-5555"
        error={errors["phone"]}
        ref={phoneRef}
      />

      <SubmitButton
        disabled={fetcher.state === "submitting" || !!fetcher.data?.ok}
        label="Finish up"
      />
    </fetcher.Form>
  );
};

export default CompleteProfile;
